import { AppRoutes } from './routes/AppRoutes';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React from 'react';
import "./App.css"

function App() {
  return (
   <>
   <AppRoutes/>
    <div className='App'>
    </div>
  </>
  );
}

export default App;
